import request from "@/utils/request";  

/** 私信部分 start*/
/**
 * 会话列表
 * @param {*} params 
 * @returns 
 */
export function sessionList(params) {
    return request({
        url: "/community/custom.php?module=front&mod=chat&ac=sessionList",
        method: "get",
        params
    });
}

/**
 * 历史消息列表
 * @param {*} params 
 * @returns 
 */
export function historyMessageList(params) {
    return request({
        url: "/community/custom.php?module=front&mod=chat&ac=historyMessageList",
        method: "get",
        params
    });
}

/**
 * 创建会话
 * @param {*} data 
 * @returns 
 */
export function createSession(data) {
    return request({
        url: "/community/custom.php?module=front&mod=chat&ac=createSession",
        method: "post",
        data
    });
}

/**
 * 接收消息
 * @param {*} data 
 * @param {*} config 额外配置选项，如取消令牌
 * @returns 
 */
export function receiveMessage(data, config = {}) {
    return request({
        url: "/community/custom.php?module=front&mod=chat&ac=receiveMessage",
        method: "post",
        data,
        ...config // 合并额外配置
    });
}

/**
 * 发送消息
 * @param {*} data 
 * @returns 
 */
export function sendMessage(data) {
    return request({
        url: "/community/custom.php?module=front&mod=chat&ac=sendMessage",
        method: "post",
        data
    });
}

/**
 * 创建会话
 * @param {*} data 
 * @returns 
 */
export function readMessage(data) {
    return request({
        url: "/community/custom.php?module=front&mod=chat&ac=readMessage",
        method: "post",
        data
    });
}

/**
 * 私信图片上传图片
 * @param {*} data 
 * @returns 
 */
export function uploadImage(data) {
    return request({
        url: "/community/custom.php?module=front&mod=chat&ac=uploadImage",
        method: "post",
        data
    });
}

// 关注
export function subscribe(data) {
    return request({
        url: '/community/custom.php?module=member&mod=member&ac=subscribe',
        method: 'post',
        data
    })
}

// 阅读所有消息
export function readAllMessage(data) {
    return request({
        url: '/community/custom.php?module=front&mod=chat&ac=readAllMessage',
        method: 'post',
        data
    })
}
/** 私信部分 end*/